import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfessionService {
  constructor(private http: HttpClient) {}

  getProfession(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/professions`);
  }

  updateProfession(
    formsId: number,
    professionId: number,
    data: any
  ): Observable<any> {
    return this.http.patch(
      `${environment.api_guia}forms/${formsId}/professions/${professionId}`,
      data
    );
  }
}
